import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Grid, Box } from '@mui/material';
import routeNames from '../../../../routes/routeNames';
import Engagement from './engagement';
import { TOTAL_PHYSICIAN_ENGAGEMENT_CHART_OPTIONS,
    FIELD_PHYSICIAN_ENGAGEMENT_CHART_OPTIONS,
    DIGITAL_PHYSICIAN_ENGAGEMENT_CHART_OPTIONS } from './constants';
import EngagementSkeleton from './skeleton';
import { customCategories, generateChartColorBasisOfChange } from '../../../../utility';
import { getWebMatrixPatientCount } from '../../../../redux/thunks/webMatrixThunks';

const DtcEngagements = (props) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [hovered, setHovered] = useState(-1);
    const [showDaysBarChart, setShowDaysBarChart] = useState(true);
    const [showMonthsBarChart, setShowMonthsBarChart] = useState(false);
    const [showAreaChart, setShowAreaChart] = useState(false);
    const { company: { id: selectedCompanyId } , isOmaniChannel } = useSelector((state) => state.company); 
    const { startDateRange, endDateRange } = useSelector((state) => state.filter); 
    const { dtcData } = useSelector((state) => state.webMatrix);
    const {
        quality_visits_for_engagement,paidMediaSummary,paidSearchSummary, isSummaryLoading
    } = dtcData;
    const { qualityVisitChart } = quality_visits_for_engagement;
    const { paidMediaBarData, totalPaidMediaSummary } = paidMediaSummary;
    const { paidSearchBarData, totalPaidSearchSummary } = paidSearchSummary;
    const MouseEnter = (index) => {
        setHovered(index);
    };
    const MouseLeave = () => {
        setHovered(-1);
    };

    const handleEngagement = (engagementType) => {
        navigate(engagementType);
    };
    const handleCharts = () =>{
        const startDate = new Date(startDateRange);
        const endDate = new Date(endDateRange);
        const differenceInMilliseconds = Math.abs(endDate - startDate);
        const differenceInDays = Math.ceil(differenceInMilliseconds / (1000 * 60 * 60 * 24));
        const totalMonths = Math.floor(differenceInDays / 30);
        if(totalMonths >6){
            setShowAreaChart(true);
            setShowMonthsBarChart(false);
            setShowDaysBarChart(false);
        } else if(differenceInDays > 31 && totalMonths<=6){
            setShowAreaChart(false);
            setShowMonthsBarChart(true);
            setShowDaysBarChart(false);
        } else {
            setShowAreaChart(false);
            setShowMonthsBarChart(false);
            setShowDaysBarChart(true);
        }
    };
    useEffect(()=>{
        if(startDateRange && endDateRange){
            handleCharts();
        }
    }, [startDateRange, endDateRange]);
    useEffect(()=>{
        if(selectedCompanyId){
            dispatch(getWebMatrixPatientCount({
                companyId: selectedCompanyId, startRange: startDateRange, endRange: endDateRange
            }));
        }
    }, [startDateRange, endDateRange,selectedCompanyId]);
    return (
        <>
            {/* Website Engagement */}
            <Grid item className="min-height-200px" lg={ 4 } sx={{
                zoom: {
                    xs: '50%',
                    lg: '100%'
                } 
            }}
            xs={12}
            onMouseEnter={() => MouseEnter(0)}
            onMouseLeave={MouseLeave}>
                <Box className="total-engagement-summary-container">
                    {isSummaryLoading ? <EngagementSkeleton key='field-engagement-skeleton' /> : <Engagement
                        chartOptions={
                            showDaysBarChart ? {
                                ...TOTAL_PHYSICIAN_ENGAGEMENT_CHART_OPTIONS,
                                xaxis: {
                                    ...TOTAL_PHYSICIAN_ENGAGEMENT_CHART_OPTIONS.xaxis,
                                    categories: customCategories(qualityVisitChart.categories,true)
                                },
                                colors: [
                                    hovered === 0 
                                        ? generateChartColorBasisOfChange(quality_visits_for_engagement.currentEngagement,
                                            quality_visits_for_engagement.previousEngagement) 
                                        : '#4EAAF8'
                                ]
                                  
                                  
                            } : 
                                showMonthsBarChart? {
                                    ...FIELD_PHYSICIAN_ENGAGEMENT_CHART_OPTIONS,
                                    xaxis: {
                                        ...FIELD_PHYSICIAN_ENGAGEMENT_CHART_OPTIONS.xaxis,
                                        categories: customCategories(qualityVisitChart.categories,true)
                                    },
                                    colors: [
                                        hovered === 0 
                                            ? generateChartColorBasisOfChange(quality_visits_for_engagement.currentEngagement,
                                                quality_visits_for_engagement.previousEngagement) 
                                            : '#4EAAF8'
                                    ]   
                                }:
                                    showAreaChart && 
                            {
                                ...DIGITAL_PHYSICIAN_ENGAGEMENT_CHART_OPTIONS,
                                xaxis: {
                                    ...DIGITAL_PHYSICIAN_ENGAGEMENT_CHART_OPTIONS.xaxis,
                                    categories: customCategories(qualityVisitChart.categories,true)
                                },
                                colors: [
                                    hovered === 0 
                                        ? generateChartColorBasisOfChange(quality_visits_for_engagement.currentEngagement,
                                            quality_visits_for_engagement.previousEngagement) 
                                        : '#4EAAF8'
                                ] 
                            }
                        }
                        chartSeries={qualityVisitChart.barData}
                        chartType={showAreaChart ? 'area' : 'bar'}
                        engagementId={0}
                        engagementSummary={quality_visits_for_engagement}
                        handleClick={()=>handleEngagement(routeNames.WEBSITE_ENGAGEMENT)}
                        selectedId ={hovered}
                        title= 'Website Engagement'
                    />}
                </Box>
            </Grid>
            {/* Paid Media Engagement */}
            <Grid item className="min-height-200px" lg={ 4 } sx={{
                zoom: {
                    xs: '50%',
                    lg: '100%'
                } 
            }} 
            xs={12}
            onMouseEnter={() => MouseEnter(1)}
            onMouseLeave={MouseLeave}>
                <Box className="field-engagement-summary-container " >
                    {isSummaryLoading ? <EngagementSkeleton key='digital-engagement-skeleton' /> : <Engagement
                        chartOptions={
                            showDaysBarChart ? {
                                ...TOTAL_PHYSICIAN_ENGAGEMENT_CHART_OPTIONS,
                                xaxis: {
                                    ...TOTAL_PHYSICIAN_ENGAGEMENT_CHART_OPTIONS.xaxis,
                                    categories: customCategories(paidMediaBarData.categories)
                                },
                                colors: [hovered=== 1 ? generateChartColorBasisOfChange(paidMediaSummary.currentEngagement,paidMediaSummary.previousEngagement) : '#4EAAF8']
                                
                            } : 
                                showMonthsBarChart? {
                                    ...FIELD_PHYSICIAN_ENGAGEMENT_CHART_OPTIONS,
                                    xaxis: {
                                        ...FIELD_PHYSICIAN_ENGAGEMENT_CHART_OPTIONS.xaxis,
                                        categories: customCategories(paidMediaBarData.categories)
                                    },
                                    colors: [hovered=== 1 ? generateChartColorBasisOfChange(paidMediaSummary.currentEngagement,paidMediaSummary.previousEngagement) : '#4EAAF8']
                                }:
                                    showAreaChart && 
                            {
                                ...DIGITAL_PHYSICIAN_ENGAGEMENT_CHART_OPTIONS,
                                xaxis: {
                                    ...DIGITAL_PHYSICIAN_ENGAGEMENT_CHART_OPTIONS.xaxis,
                                    categories: customCategories(paidMediaBarData.categories)
                                },
                                colors: [hovered=== 1 ? generateChartColorBasisOfChange(paidMediaSummary.currentEngagement,paidMediaSummary.previousEngagement) : '#4EAAF8']
                            }
                        }
                        chartSeries={paidMediaBarData.barData}
                        chartType={showAreaChart ? 'area' : 'bar'}
                        engagementId={1}
                        engagementSummary={paidMediaSummary}
                        handleClick={()=>handleEngagement(routeNames.PAID_MEDIA_ENGAGEMENT)}
                        isDtc = {true}
                        selectedId ={hovered}
                        title={'Paid Media Engagement'}
                        totalValue = {totalPaidMediaSummary}
                    />}
                </Box>
            </Grid>
            {/* Total Physician Engagement */}
            <Grid item className="min-height-200px" data-testid = "dashboard_engagement_graphs" lg={ 4 } sx={{
                zoom: {
                    xs: '50%',
                    lg: '100%'
                } 
            }}
            xs={12}
            onMouseEnter={() => MouseEnter(2)}
            onMouseLeave={MouseLeave}>
                <Box className="digital-engagement-summary-container">
                    {isSummaryLoading ? <EngagementSkeleton key='total-engagement-skeleton' /> : <Engagement
                        chartOptions={
                            showDaysBarChart ? {
                                ...TOTAL_PHYSICIAN_ENGAGEMENT_CHART_OPTIONS,
                                xaxis: {
                                    ...TOTAL_PHYSICIAN_ENGAGEMENT_CHART_OPTIONS.xaxis,
                                    categories: customCategories(paidSearchBarData.categories)
                                },
                                colors: [hovered=== 2 ? generateChartColorBasisOfChange(paidSearchSummary.currentEngagement,paidSearchSummary.previousEngagement) : '#4EAAF8']
                            } : 
                                showMonthsBarChart? {
                                    ...FIELD_PHYSICIAN_ENGAGEMENT_CHART_OPTIONS,
                                    xaxis: {
                                        ...FIELD_PHYSICIAN_ENGAGEMENT_CHART_OPTIONS.xaxis,
                                        categories: customCategories(paidSearchBarData.categories)
                                    },
                                    colors: [hovered=== 2 ? generateChartColorBasisOfChange(paidSearchSummary.currentEngagement,paidSearchSummary.previousEngagement) : '#4EAAF8']
                                }:
                                    showAreaChart && 
                            {
                                ...DIGITAL_PHYSICIAN_ENGAGEMENT_CHART_OPTIONS,
                                xaxis: {
                                    ...DIGITAL_PHYSICIAN_ENGAGEMENT_CHART_OPTIONS.xaxis,
                                    categories: customCategories(paidSearchBarData.categories)
                                },
                                colors: [hovered=== 2 ? generateChartColorBasisOfChange(paidSearchSummary.currentEngagement,paidSearchSummary.previousEngagement) : '#4EAAF8']
                            }
                        }
                        chartSeries={paidSearchBarData.barData}
                        chartType={showAreaChart ? 'area' : 'bar'}
                        engagementId={2}
                        engagementSummary={paidSearchSummary}
                        handleClick={()=>handleEngagement(routeNames.PAID_SEARCH_ENGAGEMENT)}
                        isDtc = {true}
                        selectedId ={hovered}
                        title="Paid Search Engagement"
                        totalValue = {totalPaidSearchSummary}
                    />}
                </Box>
            </Grid>
            
        </>
    );
};

export default DtcEngagements;
